import React, { useEffect, useRef } from "react";

/**
 * AdSense ad slot component.
 *
 * SETUP:
 * 1. Go to https://www.google.com/adsense/ → Ads → By ad unit → Create ad unit.
 * 2. Create 4 responsive display units:
 *      - blog-index-inline
 *      - blog-post-top
 *      - blog-post-mid
 *      - blog-post-bottom
 * 3. Copy each slot ID (a 10-digit number) and paste it into SLOT_IDS below.
 * 4. Redeploy.
 *
 * Until slot IDs are filled in, the <ins> blocks render but show nothing
 * (AdSense silently ignores placeholder IDs). No layout breakage.
 */

const CLIENT_ID = "ca-pub-8862220287996418";

export const SLOT_IDS = {
  "blog-index-inline": "0000000000", // TODO: replace with real slot ID
  "blog-post-top": "0000000000",     // TODO: replace with real slot ID
  "blog-post-mid": "0000000000",     // TODO: replace with real slot ID
  "blog-post-bottom": "0000000000",  // TODO: replace with real slot ID
};

export const Ad = ({ slot, className = "", format = "auto" }) => {
  const insRef = useRef(null);
  const pushedRef = useRef(false);
  const slotId = SLOT_IDS[slot];

  useEffect(() => {
    if (!slotId || slotId === "0000000000") return;
    if (pushedRef.current) return;
    if (typeof window === "undefined") return;
    try {
      window.adsbygoogle = window.adsbygoogle || [];
      window.adsbygoogle.push({});
      pushedRef.current = true;
    } catch (e) {
      /* ignore adblockers */
    }
  }, [slotId]);

  // Don't render anything until real slot IDs are set — prevents empty gray
  // AdSense frames that hurt UX.
  if (!slotId || slotId === "0000000000") return null;

  return (
    <div className={`my-8 flex justify-center ${className}`} data-testid={`ad-${slot}`}>
      <ins
        ref={insRef}
        className="adsbygoogle"
        style={{ display: "block", width: "100%" }}
        data-ad-client={CLIENT_ID}
        data-ad-slot={slotId}
        data-ad-format={format}
        data-full-width-responsive="true"
      />
    </div>
  );
};

export default Ad;
